import { Maybe } from 'types/graphqlTypes'
import { TSavedLaneSchema } from '../schema'
import { IEquipmentTypes } from '../types'

/**
 * Returns a SavedLaneSchema equipment value based off LaneAlert trailerType
 *
 * @example getSavedLaneSchemaEquipment('dry_van') // IEquipmentTypes.dryVan
 */
export const getSavedLaneSchemaEquipment = (
  trailerType: Maybe<string>
): TSavedLaneSchema['equipment'] => {
  switch (trailerType) {
    case 'dry_van':
      return IEquipmentTypes.dryVan
    case 'open_deck':
      return IEquipmentTypes.openDeck
    case 'reefer':
      return IEquipmentTypes.reefer
    default:
      return IEquipmentTypes.anyEquipment
  }
}
